import { MEDIA_VIEWER_CONTENT_TYPES } from '../enums/media-viewer-content-types';

/**
 * Whether the media viewer can display the given blob `documentType`.
 * Matched against {@link MediaViewerContentType} values, so it stays in sync
 * as the enum grows.
 *
 * @param documentType Blob content type (e.g. `application/pdf`).
 * @returns `true` when the media viewer supports previewing the type.
 */
export function isMediaViewerPreviewableContentType(
    documentType: string
): boolean {
    const normalized = documentType.toLowerCase();
    return MEDIA_VIEWER_CONTENT_TYPES.some((type) => type === normalized);
}
